import { render, staticRenderFns } from "./InvoiceMovementsBox.vue?vue&type=template&id=2928d805&"
import script from "./InvoiceMovementsBox.vue?vue&type=script&lang=ts&"
export * from "./InvoiceMovementsBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports